import gql from "graphql-tag"

export const getSplashImageQueryGQL = gql`
  query getSplashImageQuery {
    imageGroup(name: "Ace Splash") {
        _id
        name
        description
        subImageGroup {
        name
        path
        base64
        }
    }
  }
`

